import {
  apiRoutes,
  optimizeRoutesTspFn,
  type DefaultQueryError,
  type OptimizeRoutesTspRequestBody,
  type OptimizeRoutesTspResponse,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

export const useOptimizeRoutesTsp = (
  opts?: UseMutationOptions<
    OptimizeRoutesTspResponse,
    DefaultQueryError,
    OptimizeRoutesTspRequestBody
  >
) =>
  useMutation<
    OptimizeRoutesTspResponse,
    DefaultQueryError,
    OptimizeRoutesTspRequestBody
  >({
    mutationKey: [apiRoutes.route_optimization.tsp],
    mutationFn: optimizeRoutesTspFn,
    ...opts,
  });
